import { Box, Stack } from "@mui/material";
import { Question } from "./utils/CourseTree";
import { MockProblemContainer } from "./v2/mocktour/MockProblemContainer";
import { SkillVideoModal } from "./v2/SkillVideoModal";

interface GPPVideoProps {
  currentQuestion: Question;
}

export const GPPVideo = ({ currentQuestion }: GPPVideoProps) => {
  return (
    <MockProblemContainer currentQuestion={currentQuestion}>
      <Stack justifyContent="center" direction="row" sx={{ marginTop: "32px" }}>
        <Box
          sx={{
            width: "900px",
            marginBottom: "32px",
          }}>
          <SkillVideoModal
            embedMode={true}
            open={true}
            onClose={() => {}}
            skills={currentQuestion.question_skills}
          />
        </Box>
      </Stack>
    </MockProblemContainer>
  );
};
